import React, { useState } from 'react'
import { View, StyleSheet, TouchableOpacity } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Text, Icon } from '@components'
import { Theme } from '@theme'

interface TabItemProps {
  title: string
  isSelected: boolean
  onPress: () => void
}

export const TabItem: React.FC<TabItemProps> = ({ title, isSelected, onPress }) => {
  const theme = useTheme()
  const styles = getStyle(theme)
  return (
    <TouchableOpacity style={[styles.content, {borderBottomColor: isSelected ? theme.colors.primary : theme.colors.grey10}]} onPress={onPress}>
        <Text type="bodySmallBold" color={theme.colors.black} style={styles.title}>
        {title}
        </Text>
    </TouchableOpacity>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    content: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottomWidth: 1,
      paddingBottom: theme.spacing.sm,
      paddingHorizontal: theme.spacing.xxxl,
    },
    title: {
    }
  }) 